import { ContributionAdjustmentDetails } from 'enrollment/queries/useV3ContributionAmountQuery/utils/types';

export const ANNUAL_METHOD = 'enter_annual';
export const MONTHLY_METHOD = 'enter_monthly';
export const CONTRIBUTION_FREQUENCY_TYPE_PER_PAY_PERIOD = 'per_pay_period';
export const CONTRIBUTION_FREQUENCY_TYPE_ANNUAL = 'annual';
export const I_DO_NOT_WANT_TO_CONTRIBUTE = "no_contribution";
export const DONT_CONTRIBUTE = "no_match";
export const FIXED = "fixed";
export const INITIAL_CONTRIBUTION_ADJUSTMENTS: ContributionAdjustmentDetails = {
    employeeAdjusted: false,
    employeeisZero: false,
    employeeContribution: 0,
    employerAdjusted: false,
    employerisZero: false,
    employerContributionFrequencyAmount: 0,
    employerLumpSumAmount: 0,
    employerTotalFrequencyContribution: 0,
    scheduledContributions: []
  };
